import React from 'react';

const OwnerDashboard = () => (
  <div className="fade-in">
    <h1>Owner Dashboard</h1>
    <p>Welcome! Use the sidebar to manage vehicles and view transactions.</p>
  </div>
);
export default OwnerDashboard;